import assign from 'object-assign';
import { EventEmitter } from 'events';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'ACI_ZONES_STORE_CHANGE';
const ACIZonesStore = assign({}, EventEmitter.prototype, {
    emitChange(change) {
        this.emit(CHANGE_EVENT, change);
    },
    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
});
ACIZonesStore.dispatchToken = AdminAppDispatcher.register((payload) => {
    const action = payload.action;
    switch (action.type) {
        case ActionTypes.UPSERT_ACI_ZONES_SUCCESS:
            ACIZonesStore.emitChange(true);
            break;
        case ActionTypes.UPSERT_ACI_ZONES_FAIL:
            ACIZonesStore.emitChange(false);
            break;
        default:
            break;
    }
});
export default ACIZonesStore;
